import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { AlternateUnitOfMeasure } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class AlternateUnitOfMeasureService extends TmsWebBaseEditCreateService<
  AlternateUnitOfMeasure,
  AlternateUnitOfMeasure
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('AlternateUnitOfMeasure', $localize`Alternate Unit of Measure`);
  }

  getForUnitOfMeasure(id: string): Observable<AlternateUnitOfMeasure[]> {
    return this.httpService.get<AlternateUnitOfMeasure[]>(`${this.apiUrl}/GetForUnitOfMeasure/${id}`);
  }
}
